import api from './api';

export const modelsService = {
  // Get all models with pagination and filters
  getModels: async (params = {}) => {
    const response = await api.get('/api/models/', { params });
    return response.data;
  },

  // Get model by code
  getModel: async (code) => {
    const response = await api.get(`/api/models/${code}`);
    return response.data;
  },

  // Create new model
  createModel: async (modelData) => {
    const response = await api.post('/api/models/', modelData);
    return response.data;
  },

  // Update model (admin only)
  updateModel: async (code, modelData) => {
    const response = await api.put(`/api/models/${code}`, modelData);
    return response.data;
  },

  // Delete model (admin only)
  deleteModel: async (code) => {
    const response = await api.delete(`/api/models/${code}`);
    return response.data;
  },

  // Search models
  searchModels: async (searchTerm) => {
    const response = await api.get('/api/models/', {
      params: { search: searchTerm }
    });
    return response.data;
  },

  // Get unique brands with statistics
  getBrands: async (params = {}) => {
    const response = await api.get('/api/models/brands', { params });
    return response.data;
  },

  // Get simple brands list (for dropdowns)
  getBrandsSimple: async () => {
    const response = await api.get('/api/models/brands/simple');
    return response.data;
  },

  // Get unique device types
  getDeviceTypes: async () => {
    const response = await api.get('/api/models/device-types');
    return response.data;
  },

  // Export models to CSV
  exportModels: async (params = {}) => {
    const response = await api.get('/api/import-export/export/models', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  // Upload/replace VM program (.bin) for a model (admin, official models only)
  uploadProgram: async (code, file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/api/models/${code}/program`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Download VM program (.bin) for a model
  downloadProgram: async (code) => {
    const response = await api.get(`/api/models/${code}/program`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // Delete VM program from a model (admin, official models only)
  deleteProgram: async (code) => {
    const response = await api.delete(`/api/models/${code}/program`);
    return response.data;
  },
};
